<div class="card faq-card d-flex flex-row align-items-center justify-between" routerLink="faq">
  <rs-web-icon [icon]="immomioIconName.QuestionOutlined" [size]="16"></rs-web-icon>
  <p class="faq-card__headline">{{ faqBannerHeadline | translate }}</p>
  <p class="faq-card__text">{{ faqBannerText | translate }}</p>
  <rs-web-icon [icon]="immomioIconName.ArrowRight" [size]="16"></rs-web-icon>
</div>
